import React, { useState } from "react";
import moment from "moment";
import { useViewerStore, actions } from "@store/viewerModule/base";

import Options from "./Options";
import CustomDate from "./CustomDate";
import { DateContainer, DateRange } from "@components/common/date-picker-v2/styled";

const DatePicker = () => {
  const [{ viewerId, interval }, dispatch] = useViewerStore();
  const [isCustomSelected, setCustomSelected] = useState(false);
  const { days, isCustom } = interval;
  const selected = !isCustom ? days : "";
  const containerRef: any = React.useRef(null);

  const closeCustomDatePicker = () => {
    setCustomSelected(false);
  };

  // show datepicker only for tabs with viewerId
  if (!viewerId) {
    return null;
  }

  const genChangeHandler = (opt) => () => {
    const currentInterval = {
      startDate: opt.value ? moment()
        .subtract(opt.value, "days")
        .format() : moment().format(),
      endDate: moment().format(),
      isCustom: false,
      days: opt.value,
      isLive: opt.value ? false : true,
    };
    dispatch(actions.setAdvanced({ showAdvanceDetails: false }));
    dispatch(actions.setRowData({ rowData: {} }));
    dispatch(actions.setInterval({ interval: currentInterval }));
  };

  return (
    <DateRange id="viewers-date-picker" ref={containerRef}>
      <DateContainer>
        <Options selected={selected} genChangeHandler={genChangeHandler} />
        <CustomDate
          isCustomSelected={isCustomSelected}
          closeCustom={closeCustomDatePicker}
          containerRef={containerRef}
        />
      </DateContainer>
    </DateRange>
  );
};

export default DatePicker;
